
import dojoxVerticalRenderer from 'dojox/calendar/VerticalRenderer';
import lang from 'dojo/_base/lang';
import { compose, mdsWidget } from 'dojo/_base/declare';
import template from 'dojox/calendar/templates/VerticalRenderer.html?raw';
import topic from 'dojo/topic';
import on from 'dojo/on';
import query from 'dojo/query';
import tap from 'dojox/gesture/tap';

import domStyle from 'dojo/dom-style';
import domConstruct from 'dojo/dom-construct';
import domClass from 'dojo/dom-class';
import domAttr from 'dojo/dom-attr';
import methodHooks from 'more/mdsMethodHooks';


class moreCoreVerticalRenderer extends methodHooks(compose(dojoxVerticalRenderer)) {
	[key: string]: any;

	templateString: any = template;

	_doubleTouchHandler: any = null;
	_singleTapHandler: any = null;
	bHideColumHeadIfNeeded: boolean = false;
	bShowEndTime: boolean = false;

	compactView: boolean = false;

	fallbackcolor: string = "var(--defaultItemColorBG)";
	fallbackcolorTxt: string = "var(--defaultItemColorTXT)";

	columnView_bodyText_attribute: string;
	columnView_headText_attribute: string;

	startTimeLabel_backColor: string = "var(--defaultVLabelHeadBG)";
	startTimeLabel_textColor: string = "var(--defaultVLabelHeadTXT)";


	public _isElementVisible(elt: string, startHidden?: any, endHidden?: any, size?:any):boolean {

		switch (elt) {
			case "startTimeLabel":
				return this.bHideColumHeadIfNeeded == false;
				break;
			case "endTimeLabel":
				return this.bShowEndTime || false;
				break;
		}
		return super._isElementVisible.apply(this, arguments as any);
	}

	setColumnView_bodyText_attribute(value: string): void {
		this.columnView_bodyText_attribute = value;
		this.updateRendering();
	}

	setColumnView_headText_attribute(value: string): void {
		this.columnView_headText_attribute = value;
		this.updateRendering();

	}

	updateRendering(w?, h?): void {

		if (!this.columnView_bodyText_attribute) this.columnView_bodyText_attribute = "columnview_body_text"; // default
		if (!this.columnView_headText_attribute) this.columnView_headText_attribute = "columnview_head_text";
		super.updateRendering.apply(this, arguments as any);

		var rd: any = this.owner.renderData;

		var size: any = this._orientation == "vertical" ? h : w;
		var startHidden : boolean= rd.dateModule.compare(this.item.range[0], this.item.startTime) != 0;
		var endHidden: boolean = rd.dateModule.compare(this.item.range[1], this.item.endTime) != 0;
		var visible: boolean;

		if (this.startTimeLabel) {
			visible = this._isElementVisible("startTimeLabel", startHidden, endHidden, size);

			//// Label verstecken bei Items kleiner als 70 px, column_body text = colum_head_text


			domClass.toggle(this.startTimeLabel, "w3-hide", !visible);
			if (visible) {
				var timeText :string = this._formatTime(rd, this.item.startTime);
				if (this.bShowEndTime === true) {
					timeText = timeText + " - " + this._formatTime(rd, this.item.endTime);
				}
				(this._setText as any)(this.startTimeLabel, timeText);
			}
		}

		//  Farben setzen
		//
		//console.log("iitem color: ", this.item._item);
		
		var itemColor: { backColor: string, textColor: string } = this.getItemColor(this.item._item);

		if (!itemColor) {
			
			itemColor = this.getItemColor(this.item._item);
        }
		

		if (itemColor) {
			var colorBack: string = itemColor.backColor;
			var colorText: string = itemColor.textColor;

			if (colorBack && colorBack.indexOf("rgb") == -1) {
				if (colorBack.indexOf("#") == -1) colorBack = "#" + colorBack;
			}

			if (colorText && colorText.indexOf("rgb") == -1) {
				if (colorText.indexOf("#") == -1) colorText = "#" + colorText;
			}

			// ob die Hexwerte nun mit oder ohne "#" kommen is uns wurscht
			this.domNode.style.setProperty("--bgColor", colorBack);
			this.domNode.style.setProperty("--txtColor", colorText);

			let Collection: HTMLCollection = <HTMLCollection>(<any>query(".bg", this.domNode));

			for (let p = 0; p < Collection.length; p++) {
				let node: HTMLElement = Collection[p] as HTMLElement;

				//domStyle.set(node, "backgroundColor", colorBack);
			}
			if (this.summaryLabel) {
				//domStyle.set(this.summaryLabel, { "color": colorText });
			}


			// label opacity auf die column opacity abstimmen
			var labelBack: string = colorBack ? colorBack : this.startTimeLabel_backColor;
			var labelText: string = colorText ? colorText : this.startTimeLabel_textColor;

			if (colorText.length == 9 && labelText.length == 7) {
				labelText = this.startTimeLabel_textColor + colorText.slice(7);
			} else if (colorText.length == 9 && labelText.length == 9) {
				labelText = this.startTimeLabel_textColor.slice(0, 7);
				labelText = labelText + colorText.slice(7);
			} else if (colorText.length == 7 && labelText.length == 9) {
				labelText = this.startTimeLabel_textColor.slice(0, 7);
			}

			if (colorBack.length == 9 && labelBack.length == 7) {
				labelBack = this.startTimeLabel_backColor + colorBack.slice(7);
			} else if (colorBack.length == 9 && labelBack.length == 9) {
				labelBack = this.startTimeLabel_backColor.slice(0, 7);
				labelBack = labelBack + colorBack.slice(7);
			} else if (colorBack.length == 7 && labelBack.length == 9) {
				labelBack = this.startTimeLabel_backColor.slice(0, 7);
			}


			if (this.startTimeLabel) {
				domStyle.set(this.startTimeLabel,
					{
						"color": labelText,
						"backgroundColor": labelBack
					});

			}
		}
		// Attribut für Saltenansicht (Kopf) setzen
		// 
		let headText = this.item?._item[this.columnView_headText_attribute];
		let bodyText: string = this.item?._item[this.columnView_bodyText_attribute];
		//if ((this.item.end - this.item.start) < 70) {
		//	bodyText = this.item._item[this.columnView_headText_attribute];
		//}

		if ( headText == bodyText || !headText ) visible = false;

		let columnViewHead: HTMLCollection = <HTMLCollection>(<any>query(".columnViewHead", this.startTimeLabel));
		if (columnViewHead.length > 0 && visible) {
			domAttr.set(columnViewHead[0], "innerHTML", headText);
		} else if (visible) {
			domConstruct.create("div", {
				"class": "columnViewHead",
				"innerHTML": headText
			}, this.startTimeLabel, "last");
		}

		// Body text


		//if ((this.item.end - this.item.start) < 20) bodyText = null;

		let columnContentDiv = domConstruct.create("div", {
			"innerHTML": bodyText ,
			"style": "text-overflow: ellipsis; word-break:break-word;"
		}, this.summaryLabel, "only");



	}

	getItemColor(item): { backColor: string, textColor: string } {
		//
		//  wird in moreCoreCalendar überschrieben!
		//  haxxxxx0r
		//
		return { backColor: this.fallbackcolor, textColor: this.fallbackcolorTxt }; // default colors
	}
	_onItemDoubleTouch() :void {
		// event nur bei touch-geräten auf onItemDoubleClick umleiten
		if ("ontouchstart" in document.documentElement) {
			this.owner._onItemDoubleClick({ item: this.item._item });
		}
	}
	_attachDoubleTouchEvent() :void {
		this._detachDoubleTouchEvent();

		this._doubleTouchHandler = on(this.domNode, tap.doubletap, lang.hitch(this, "_onItemDoubleTouch"));
	}
	_detachDoubleTouchEvent():void {
		if (this._doubleTouchHandler != null) {
			this._doubleTouchHandler.remove();
		}
	}
	_recycleRenderer():void {
		super["_recycleRenderer" as any].apply(this, arguments as any);

		this._detachDoubleTouchEvent();

	}

	setFallbackcolor(value: string): void {
		this.fallbackcolor = value;
		this.updateRendering();
	}

	_onItemSingleTap(evt) {
		// event nur bei touch-geräten auf onItemClick umleiten
		if ("ontouchstart" in document.documentElement) {
			this.owner._onItemClick({ item: this.item._item });
		}
	}
	_attachSingleTapEvent(): void {
		this._detachSingleTapEvent();

		this._singleTapHandler = on(this.domNode, tap, lang.hitch(this, "_onItemSingleTap"));
	}
	_detachSingleTapEvent(): void {
		if (this._singleTapHandler != null) {
			this._singleTapHandler.remove();
		}
	}


	postCreate(): void {
		super.postCreate.apply(this, arguments as any);

		this.domNode.style.removeProperty("zIndex");
		this.domNode.style.removeProperty("z-index");
		
		if ("ontouchstart" in document.documentElement) {
			console.log("touch event in documentElement!!");
			this._attachDoubleTouchEvent();
			this._attachSingleTapEvent();
		}

		topic.subscribe("moreCoreCalendar/bShowEndTime", lang.hitch(this, function (bool) {

			this.bShowEndTime = bool;
			this.startup();
		}));

		topic.subscribe("moreCoreCalendar/bHideColumHeadIfNeeded", lang.hitch(this, function (bool) {
			this.bHideColumHeadIfNeeded = bool;
			this.startup();
		}));

		topic.subscribe("moreCoreCalendar/setColumnBodyText", lang.hitch(this, function (value:string) {
			this.setColumnView_bodyText_attribute(value);
		}));
		topic.subscribe("moreCoreCalendar/setColumnHeadText", lang.hitch(this, function (value:string) {
			this.setColumnView_headText_attribute(value);
		}));

		topic.subscribe("moreCoreCalendar/setFallbackcolor", lang.hitch(this, function (value: string) {
			this.setFallbackcolor(value);
		}));

		topic.subscribe("MainProperties/cbShowEndTime_checked", lang.hitch(this, function (bool) {
			this.bShowEndTime = bool;
		}));
	}

	startup(): void {
		super.startup.apply(this, arguments as any);

		
	}


}

export default mdsWidget(moreCoreVerticalRenderer);